<template>
  <div class="container lg:py-16 py-10 px-3">
    <div class="flex flex-col gap-5 items-center w-full">
      <div class="flex gap-8 md:flex-row flex-col-reverse">
        <div class="flex flex-col h-full md:w-1/2 gap-5">
          <div class="text-primary text-base font-semibold uppercase flex items-center">
            <div class="h-1 w-16 bg-primary mr-4"></div>Hire Best Plumbing
          </div>
          <div class="lg:text-4xl text-2xl font-semibold  text-center lg:text-left">Gill Brother: Choose the Top Master Plumbing & Heating Service Company in the GTA

          </div>
          <div class="text-base text-grey text-center lg:text-left">Looking for reliable and top-notch plumbing and heating services? Your search ends here! Our dedicated team of experts is committed to providing you with the best plumbing and heating solutions in the GTA.
 </div>
        </div>
        <div class=" h-auto md:w-1/2  overflow-hidden">
          <img src="../../assets//v-1.1/hire-plumber.png" class="w-full rounded h-full" />
        </div>
      </div>
      <div class="grid lg:grid-cols-3 grid-cols-1 gap-10 py-5 border-b-2 lg:mt-3">
        <div class="flex flex-col gap-5" v-for="item, index in img_data" :key="index">
          <div class="text-2xl font-semibold font-primary text-center lg:text-left">{{ item.heading }}</div>
          <div class="text-base w-full text-center text-grey lg:text-left">{{ item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

const img_data = [
  {
    heading: "Unparalleled Expertise",
    desc: "When you choose us, you gain access to a team of highly skilled and experienced plumbers and heating technicians. Our professionals have undergone rigorous training in their respective fields, ensuring that they possess the necessary expertise to handle any plumbing or heating issue. ",
  },
  {
    heading: "Prompt and Reliable",
    desc: "We understand that plumbing and heating problems can arise at any time, often causing inconvenience and discomfort. That's why we prioritize promptness and reliability. When you hire us, you can trust that our team will respond swiftly to your service request. ",
  },
  {
    heading: "Transparent Pricing",
    desc: "Say goodbye to uncertainties and hidden costs! We believe in transparent pricing, providing you with detailed quotes upfront. Our commitment to transparency means you'll know exactly what to expect, with no surprise fees or hidden charges. ",
  },
];
</script>